import { loanCicHistoryApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const getLoanCicHistoryAction = catchAsyncActionError(({ loanId }) => async () => {
  const { data } = await loanCicHistoryApi.getCicHistory({ loanId });

  return data;
});

export const editLoanCicChangeAction = catchAsyncActionError(
  ({ loanId, changeId, cicReasonId, comment }) =>
    async () => {
      const { data } = await loanCicHistoryApi.editCicChange({
        loanId,
        changeId,
        cicReasonId,
        comment,
      });

      return data;
    },
);

export const editLoanCicFeeChangeAction = catchAsyncActionError(
  ({ loanId, feeChangeId, cicReasonId, comment }) =>
    async () => {
      const { data } = await loanCicHistoryApi.editCicFeeChange({
        loanId,
        feeChangeId,
        cicReasonId,
        comment,
      });

      return data;
    },
);
